<template>
  <div v-if="raw==1">
    <router-view />
  </div>
  <el-container v-else class="fill-in header-main-layout" :class="$root.siteRenderer">
    <el-header>
      <TopBar />
      <!-- <TabsNav /> -->
      <!-- <Breadcrumb /> -->
    </el-header>
    <el-main class="main-container">
      <div class="main-back">
        <transition name="fade">
          <template v-if="isTabbedMenu">
            <keep-alive :max="6">
              <router-view />
            </keep-alive>
          </template>
          <router-view v-else />
        </transition>
        <IFrameHolder />
      </div>
      <Footer class="footer"/>
    </el-main>
  </el-container>
</template>

<script>
import { getIsTabbedMenu } from "@/framework/utils/config";
import TopBar from "./components/TopBar.vue";
import Footer from "@/framework/components/Footer";
import IFrameHolder from "@/framework/components/iframe/IFrameHolder";
import Breadcrumb from "@/framework/components/Breadcrumb";
import TabsNav from "@/framework/components/TabsNav";
import LayoutMixin from "@/framework/layouts/LayoutMixin.js";
export default {
  name: "HeaderTiledMainLayout",
  mixins: [LayoutMixin],
  data() {
    return {
      isTabbedMenu: getIsTabbedMenu(),
    };
  },
  components: {
    TopBar,
    Footer,
    IFrameHolder,
    Breadcrumb,
    TabsNav
  }
};
</script>
<style lang="scss" scoped>
.main-container{
  padding: 0;
  &::-webkit-scrollbar-track-piece {
    background-color: $mainBackColor;
  }
  /deep/ .basic-container{
    .basic-container-header{
      border-bottom: solid #e2e4e6 1px;
    }
  }
  /deep/ .raw{
    background: #fff;
  }
}
</style>